import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import useIsAhr from "src/utils/hooks/useIsAhr";
import __ from "src/utils/Translations";

export const useCompanyBreadcrumbs = (
  locations: { label: string; path: string }[]
) => {
  const companyId = useCompanyId();
  const companyName = useCompanyName();
  const isAhr = useIsAhr();
  const urlPrefix = isAhr ? "/ahr" : `/company/edit/${companyId}`;

  const baseBreadcrumbs = isAhr
    ? [{ label: `${__("Zarządzanie firmą")} ${companyName}`, to: `/ahr` }]
    : [
        { label: __("Firma"), to: "/company" },
        { label: __("Lista firm"), to: "/company/list" },
        {
          label: `${__("Zarządzanie firmą")} ${companyName} (${companyId})`,
          to: urlPrefix,
        },
      ];

  return baseBreadcrumbs.concat(
    locations.map(({ label, path }) => ({ label, to: urlPrefix + path }))
  );
};
